import { useEffect } from "react";

/**
 * Reindirizza subito il browser a un file HTML statico (es. /mabella-fest.html).
 * Utile per avere URL corti "brandizzati" tipo /mabella che puntano alla landing.
 */
export default function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-rose-50 to-white">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#B87A8A] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-gray-500 text-sm">Caricamento...</p>
      </div>
    </div>
  );
}
